<template>
	<div class="message-chat">
		<van-nav-bar fixed placeholder :title="$route.meta.title" left-arrow @click-left="onClickLeft" />
		<div class="top-wrapper" v-if="!isLandlord">
			<section class="g-house-card-list-layout">
				<div class="scroll-wrapper">
					<ul class="house-card-list">
						<li class="house-card-list-item f-border-bottom-line-gray">
							<section class="g-house-card-list-item-layout">
								<van-image :src="house.pictureList[0]" alt="house-image" class="house-image" />
								<div class="house-info">
									<h1 class="title" v-text="house.name"></h1>
									<p class="date f-toe" v-text="house.tags.join('、')"></p>
								</div>
								<div class="send-button" @click="onSendHouse">发送房屋</div>
							</section>
						</li>
					</ul>
				</div>
			</section>
		</div>
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="下拉加载历史...">
			<ul class="message-list">
				<li class="message-list-item" v-for="(item, index) in messages" v-bind:key="index">
					<section :class="`g-${item.key}-message-bubble-layout`">
						<div class="message-state-icon" v-if="item.key === 'sender'">
							<i :class="`icon${item.loading ? ' icon-send-loading' : ''}`"></i>
						</div>
						<div class="user-avatar avatar" v-if="item.key === 'answer'">
							<div class="avatar__wrap avatar__wrap--arc">
								<van-image :src="item.avatar" fit="cover" round width="35" height="35" />
							</div>
						</div>
						<div class="card-bubble" v-if="item.house" @click="onHouse(item.house.id)">
							<section class="g-house-info-text-layout">
								<van-image :src="house.pictureList[0]" alt="house-image" class="house-image" />
								<div class="house-info">
									<h1 class="title" v-text="house.name"></h1>
									<p class="date f-toe" v-text="house.tags.join('、')"></p>
								</div>
							</section>
						</div>
						<section class="g-system-tips-layout" v-else-if="item.tips">
							<p class="tips">
								{{ item.tips }}
							</p>
						</section>
						<div class="message-bubble" v-else>
							<section class="g-normal-text-layout" v-text="item.text"></section>
						</div>
						<div class="user-avatar avatar" v-if="item.key === 'sender'">
							<div class="avatar__wrap avatar__wrap--arc">
								<van-image :src="item.avatar" fit="cover" round width="35" height="35" />
							</div>
						</div>
					</section>
				</li>
			</ul>
		</van-pull-refresh>
		<div class="send-tips" v-show="showFailedToSend">聊天消息不能发送</div>
		<div class="send-tips" style="bottom: 52px" v-show="showDisconnect">
			聊天网络断开
		</div>
		<section class="g-message-input-layout">
			<div class="input-wrapper">
				<input type="text" class="input" v-model="text" @focus="showEmojiPanel = false" /><span
					class="icon-emoji" @click="onEmojiPanel"></span><span class="icon-send"
					@click="onSendMessage"></span>
			</div>
			<p class="emoji-panel" v-show="showEmojiPanel">
				<span class="emoji">😀</span><span class="emoji">😁</span><span class="emoji">😂</span><span
					class="emoji">😃</span><span class="emoji">😄</span><span class="emoji">😅</span><span
					class="emoji">😆</span><span class="emoji">😆</span><span class="emoji">😇</span><span
					class="emoji">😈</span><span class="emoji">😉</span><span class="emoji">😊</span><span
					class="emoji">😋</span><span class="emoji">😌</span><span class="emoji">😍</span><span
					class="emoji">😎</span><span class="emoji">😏</span><span class="emoji">😐</span><span
					class="emoji">😑</span><span class="emoji">😒</span><span class="emoji">😓</span><span
					class="emoji">😔</span><span class="emoji">😕</span><span class="emoji">😖</span><span
					class="emoji">😗</span><span class="emoji">😘</span><span class="emoji">😙</span><span
					class="emoji">😚</span><span class="emoji">😛</span><span class="emoji">😜</span><span
					class="emoji">😝</span><span class="emoji">😞</span><span class="emoji">😟</span><span
					class="emoji">😠</span><span class="emoji">😡</span><span class="emoji">😢</span><span
					class="emoji">😣</span><span class="emoji">😤</span><span class="emoji">😥</span><span
					class="emoji">😦</span><span class="emoji">😧</span><span class="emoji">😨</span><span
					class="emoji">😩</span><span class="emoji">😪</span><span class="emoji">😫</span><span
					class="emoji">😬</span><span class="emoji">😭</span><span class="emoji">😮</span><span
					class="emoji">😯</span><span class="emoji">😰</span><span class="emoji">😱</span><span
					class="emoji">😲</span><span class="emoji">😳</span><span class="emoji">😴</span><span
					class="emoji">😵</span><span class="emoji">😶</span><span class="emoji">😷</span><span
					class="emoji">😸</span><span class="emoji">😹</span><span class="emoji">😺</span><span
					class="emoji">😻</span><span class="emoji">😼</span><span class="emoji">😽</span><span
					class="emoji">😾</span><span class="emoji">😿</span><span class="emoji">🙀</span><span
					class="emoji">🙁</span><span class="emoji">🙂</span><span class="emoji">🙃</span><span
					class="emoji">🙄</span><span class="emoji">🤐</span><span class="emoji">🤑</span><span
					class="emoji">🤒</span><span class="emoji">🤓</span><span class="emoji">🤔</span><span
					class="emoji">🤕</span><span class="emoji">🤖</span><span class="emoji">🤗</span><span
					class="emoji">🤘</span><span class="emoji">🤘</span><span class="emoji">🤙</span><span
					class="emoji">🤚</span><span class="emoji">🤛</span><span class="emoji">🤜</span><span
					class="emoji">🤝</span><span class="emoji">🤞</span><span class="emoji">🤠</span><span
					class="emoji">🤡</span><span class="emoji">🤢</span><span class="emoji">🤣</span><span
					class="emoji">🤤</span><span class="emoji">🤥</span><span class="emoji">🤦</span><span
					class="emoji">🤧</span><span class="emoji">🤰</span><span class="emoji">🤳</span><span
					class="emoji">🤴</span><span class="emoji">🤵</span><span class="emoji">🤶</span><span
					class="emoji">🤷</span>
			</p>
		</section>
	</div>
</template>

<script>
	import io from "socket.io-client";
	import {
		NavBar as VanNavBar,
		Image as VanImage,
		PullRefresh as VanPullRefresh,
	} from "vant";

	export default {
		components: {
			VanNavBar,
			VanImage,
			VanPullRefresh,
		},
		data() {
			return {
				isLandlord: true,
				page: 1,
				text: "",
				messages: [],
				isLoading: false,
				showEmojiPanel: false,
				showFailedToSend: false,
				showDisconnect: false,
				user: {},
				house: {
					tags: [],
					pictureList: [],
				},
			};
		},
		mounted() {
			if (this.$route.query.token) {
				localStorage.setItem("token", this.$route.query.token)
			}
			const {
				chatId
			} = this.$route.query;
			if (chatId) {
				const socket = io(process.env.VUE_APP_WS_HOST, {
					path: "/services/myservice/socket.io",
					query: {
						token: localStorage.getItem("token"),
						chatId,
					},
				});
				socket.on("connect", () => {
					this.showDisconnect = false;
				});
				socket.on("disconnect", () => {
					this.showDisconnect = true;
				});
				socket.on("user", (user) => {
					this.user = user;
				});
				socket.on("join", (house) => {
					this.house = house;
					this.isLandlord = house.isLandlord;
				});
				socket.on("message", (message) => {
					this.messages.push({
						...message,
						key: message.userId ?
							this.user.id === message.userId ?
							"sender" :
							"answer" :
							"system",
						loading: false,
					});
					this.toScrollBottom();
				});
				socket.on("history", (messages) => {
					const isToScrollBottom = !this.messages.length;
					this.messages.unshift(
						...(messages || []).map((message) => ({
							...message,
							key: this.user.id === message.userId ? "sender" : "answer",
						}))
					);
					this.isLoading = false;
					isToScrollBottom && this.toScrollBottom();
				});

				this.socket = socket;

				this.onRefresh();
			}
			document.querySelectorAll(".emoji").forEach((e) => {
				e.addEventListener("click", (e) => {
					this.text += e.target.innerText;
				});
			});
		},
		methods: {
			onHouse(id) {
				if (this.isWechat()) {
					wx.miniProgram.navigateTo({
						url: "/pages/hotel_list/room_info?room_id=" + id,
					});
				}
			},
			toScrollBottom() {
				this.$nextTick(() => {
					window.scrollTo(0, document.body.scrollHeight);
				});
			},
			onSendHouse() {
				this.socket.emit("message", {
					roomId: this.house.id
				});
				this.toScrollBottom();
			},
			onSendMessage() {
				if (!this.text.trim()) {
					return;
				}
				this.socket.emit("message", {
					text: this.text,
					loading: true,
				});
				this.text = "";
				this.showEmojiPanel = false;
			},
			onEmojiPanel() {
				this.showEmojiPanel = !this.showEmojiPanel;
			},
			onRefresh() {
				this.socket.emit("history", {
					id: this.messages[0]?.id,
				});
			},
		},
	};
</script>

<style lang="less">
	.message-chat {
		width: 100%;
		min-height: 100vh;
		background-color: #f7f9fb;

		.g-house-card-list-layout {
			background-color: #fff;

			.scroll-wrapper {
				max-height: 93.33333vw;
				overflow: auto;
				box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.06);

				.house-card-list {
					padding: 0 20px;

					.tips {
						padding-top: 20px;
						line-height: 12px;
						font-size: 10px;
						color: #999;
					}

					.f-border-bottom-line-gray {
						position: relative;
						border: none;
					}

					.g-house-card-list-item-layout {
						display: flex;
						-ms-flex-align: center;
						align-items: center;
						justify-content: space-between;
						padding: 20px 0;
						background-color: #fff;

						.house-image {
							-ms-flex: 0 0 50px;
							flex: 0 0 50px;
							width: 50px;
							height: 50px;
							margin-right: 10px;
						}

						.house-info {
							-ms-flex: 1;
							flex: 1;
							width: 54.66667vw;

							.title {
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								overflow: hidden;
								line-height: 16px;
								font-size: 12px;
								font-weight: 400;
								color: #333;
							}

							.date {
								margin-top: 6px;
								font-size: 11px;
								font-weight: 300;
								color: #999;
							}
						}

						.send-button {
							margin-left: 10px;
							padding: 5px;
							line-height: 12px;
							font-size: 12px;
							border: 0.5px solid #ff9645;
							border-radius: 4px;
							color: #ff9645;
						}

						.button-disabled {
							border: 1px solid #999;
							color: #999;
						}
					}
				}
			}

			.tab {
				display: flex;
				-ms-flex-align: center;
				align-items: center;
				position: absolute;
				bottom: -22px;
				left: 50%;
				-ms-transform: translateX(-50%);
				transform: translateX(-50%);
				padding: 5px 9px;
				text-align: center;
				border-bottom-right-radius: 8px;
				border-bottom-left-radius: 8px;
				background-color: #fff;
				box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.06);

				.text {
					margin-right: 5px;
					line-height: 12px;
					font-weight: 300;
					font-size: 10px;
					color: #666;
				}
			}
		}

		.g-banner-tips-layout {
			padding: 7px 20px;
			line-height: 16px;
			font-size: 12px;
			color: #ff9645;
			background: #fff7f0;

			.close {
				text-decoration: underline;
			}
		}

		.message-list {
			padding: 10px 20px;
			padding-bottom: 63px;

			.message-list-item {
				margin-bottom: 20px;

				&:last-child {
					margin-bottom: 0;
				}

				.g-sender-message-bubble-layout {
					position: relative;
					display: flex;
					-ms-flex-pack: end;
					justify-content: flex-end;
					margin-left: 16px;

					.message-state-icon {
						position: relative;
						-ms-flex: 0 0 14px;
						flex: 0 0 14px;
						width: 14px;
						margin-right: 5px;

						.icon {
							position: absolute;
							left: 0;
							bottom: 5px;
						}

						.icon-send-loading {
							display: inline-block;
							background-image: url(../../assets/page-IM.247163ca.png);
							width: 14px;
							height: 14px;
							background-size: 114px 83px;
						}

						.icon-send-loading {
							background-position: -82px -56px;
							animation: rotate-send-loading 0.7s linear infinite;
						}
					}

					.message-bubble {
						position: relative;
						border-radius: 4px;
						background: #fbcd64;

						&:before {
							display: inline-block;
							position: absolute;
							content: "";
							top: 13px;
							right: -4px;
							width: 8px;
							height: 8px;
							box-sizing: border-box;
							-ms-transform: rotate(135deg);
							transform: rotate(135deg);
							background: inherit;
						}

						.g-normal-text-layout {
							padding: 10px;
							line-height: 15px;
							word-break: break-all;
							word-wrap: break-word;
							font-size: 14px;
							color: #333;
						}
					}
				}

				.g-answer-message-bubble-layout {
					display: flex;
					margin-right: 35px;

					.user-avatar {
						flex: 0 0 35px;
						width: 35px;
						height: 35px;
						margin-right: 15px;
					}

					.message-bubble {
						position: relative;
						border-radius: 4px;
						background: #fff;
						border: 0.5px solid #dadada;

						&:before {
							display: inline-block;
							position: absolute;
							content: "";
							top: 12px;
							left: -4px;
							width: 8px;
							height: 8px;
							box-sizing: border-box;
							-ms-transform: rotate(135deg);
							transform: rotate(135deg);
							border-width: 0 0.5px 0.5px 0;
							border-style: none solid solid none;
							border-color: #dadada;
							background: inherit;
						}

						.g-normal-text-layout {
							padding: 10px;
							line-height: 15px;
							word-break: break-all;
							word-wrap: break-word;
							font-size: 14px;
							color: #333;
						}
					}

					.red-packet-bubble {
						position: relative;
						border-radius: 4px;
						border: 0.5px solid #fcefe5;
						background: #ffe4cf;
					}

					&:before {
						display: inline-block;
						position: absolute;
						content: "";
						top: 12px;
						left: -4px;
						width: 8px;
						height: 8px;
						box-sizing: border-box;
						-ms-transform: rotate(135deg);
						transform: rotate(135deg);
						border-width: 0 0.5px 0.5px 0;
						border-style: none solid solid none;
						border-color: #ffe4cf;
						background: inherit;
					}

					.image-bubble {
						position: relative;
						border-radius: 4px;
					}

					.image-bubble:before {
						display: inline-block;
						position: absolute;
						content: "";
						top: 12px;
						left: -4px;
						width: 8px;
						height: 8px;
						z-index: -1;
						box-sizing: border-box;
						-ms-transform: rotate(135deg);
						transform: rotate(135deg);
						background: inherit;
						background-size: auto;
					}

					.card-bubble::before {
						display: inline-block;
						position: absolute;
						content: "";
						top: 12px;
						left: -4px;
						width: 8px;
						height: 8px;
						box-sizing: border-box;
						-webkit-transform: rotate(135deg);
						transform: rotate(135deg);
						border-width: 0 0.5px 0.5px 0;
						border-style: none solid solid none;
						border-color: #dadada;
						background: inherit;
					}
				}
			}
		}

		.top-wrapper {
			position: fixed;
			top: 0;
			z-index: 999;
			left: 0;
			width: 100%;
		}

		.van-nav-bar__placeholder+.top-wrapper {
			top: 44px;
		}

		.van-pull-refresh {
			min-height: calc(100vh);
		}

		.van-nav-bar__placeholder+.van-pull-refresh {
			min-height: calc(100vh - 46px);
		}

		.top-wrapper+.van-pull-refresh .message-list {
			padding-top: 103px;
		}

		.card-bubble {
			position: relative;
			border-radius: 4px;
			border: 0.5px solid #dadada;
			background: #fff;

			&:before {
				display: inline-block;
				position: absolute;
				content: "";
				top: 12px;
				right: -4px;
				width: 8px;
				height: 8px;
				box-sizing: border-box;
				-ms-transform: rotate(135deg);
				transform: rotate(135deg);
				border-width: 0.5px 0 0 0.5px;
				border-style: solid none none solid;
				border-color: #dadada;
				background: inherit;
			}

			.g-house-info-text-layout {
				display: flex;
				-ms-flex-align: center;
				align-items: center;
				-ms-flex-pack: justify;
				justify-content: space-between;
				padding: 10px;

				.house-image {
					flex: 0 0 50px;
					width: 50px;
					height: 50px;
					margin-right: 10px;
				}

				.house-info {
					width: 44.8vw;

					.title {
						min-height: 33px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						line-height: 16px;
						font-size: 12px;
						font-weight: 400;
						color: #333;
					}

					.date {
						margin-top: 6px;
						font-size: 11px;
						font-weight: 300;
						color: #999;
					}
				}
			}
		}

		.user-avatar {
			flex: 0 0 35px;
			width: 35px;
			height: 35px;
			margin-left: 14px;
		}

		.g-system-tips-layout {
			width: 100%;
			text-align: center;

			.tips {
				display: inline-block;
				padding: 2px 4px;
				line-height: 12px;
				border-radius: 2px;
				border-top: 1.2px solid rgba(0, 0, 0, 0);
				text-align: center;
				font-size: 10px;
				background: #dadada;
				color: #666;
			}
		}

		.send-tips {
			position: fixed;
			bottom: 51px;
			left: 0;
			width: 100%;
			padding: 8px 20px;
			font-size: 14px;
			color: #fff;
			background: hsla(0, 100%, 70%, 0.9);
		}

		@-webkit-keyframes rotate-send-loading {
			0% {
				-webkit-transform: rotate(0deg);
				transform: rotate(0deg);
			}

			to {
				-webkit-transform: rotate(1turn);
				transform: rotate(1turn);
			}
		}

		@keyframes rotate-send-loading {
			0% {
				-webkit-transform: rotate(0deg);
				transform: rotate(0deg);
			}

			to {
				-webkit-transform: rotate(1turn);
				transform: rotate(1turn);
			}
		}

		.g-message-input-layout {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;

			.input-wrapper {
				display: -webkit-box;
				display: -webkit-flex;
				display: -ms-flexbox;
				display: flex;
				-webkit-box-pack: justify;
				-webkit-justify-content: space-between;
				-ms-flex-pack: justify;
				justify-content: space-between;
				-webkit-box-align: center;
				-webkit-align-items: center;
				-ms-flex-align: center;
				align-items: center;
				padding: 8px 20px;
				-webkit-box-shadow: 3px 0 7px 0 rgba(0, 0, 0, 0.08);
				box-shadow: 3px 0 7px 0 rgba(0, 0, 0, 0.08);
				background: #fff;

				.input {
					-webkit-box-flex: 1;
					-webkit-flex: 1;
					-ms-flex: 1;
					flex: 1;
					height: 35px;
					z-index: 100;
					line-height: 35px;
					padding-left: 5px;
					border: 0.5px solid #dadada;
					-webkit-border-radius: 2px;
					border-radius: 2px;
					background: #f7f9fb;
					-webkit-appearance: none;
				}

				.icon-emoji,
				.icon-send {
					display: inline-block;
					background-image: url(../../assets/page-IM.247163ca.png);
					height: 24px;
					background-size: 114px 83px;
				}

				.icon-emoji {
					margin: 0 15px;
					background-position: -71px -29px;
					width: 24px;
				}

				.icon-send {
					background-position: 0 0;
					width: 40px;
				}
			}

			.emoji-panel {
				display: -webkit-box;
				display: -webkit-flex;
				display: -ms-flexbox;
				display: flex;
				-webkit-box-pack: justify;
				-webkit-justify-content: space-between;
				-ms-flex-pack: justify;
				justify-content: space-between;
				-webkit-box-align: center;
				-webkit-align-items: center;
				-ms-flex-align: center;
				align-items: center;
				-webkit-flex-wrap: wrap;
				-ms-flex-wrap: wrap;
				flex-wrap: wrap;
				overflow: auto;
				height: 120px;
				padding: 10px 0;
				background-color: #f7f9fb;

				.emoji {
					width: 10%;
					margin: 0 0 5px 0;
					line-height: 20px;
					text-align: center;
					font-size: 20px;
				}
			}
		}
	}
</style>